<template>
  <div class="dashboard-home">

    <div class="dashboard-hero">
      <div class="container-fluid">
        <div class="hero-inner">
          <div>
            <h1 class="hero-title">لوحة التحكم</h1>
            <p class="hero-subtitle">إدارة الطلاب والمحتوى التعليمي</p>
          </div>
          <div class="hero-badge">
            <i class="pi pi-shield"></i>
            <span>بوابة الإدارة</span>
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid py-4" style="padding-left:1.5rem; padding-right:1.5rem;">


      <div v-if="loading" class="text-center py-5">
        <i class="pi pi-spin pi-spinner" style="font-size:2rem;"></i>
      </div>

      <template v-else>

        <div v-if="activeGrades.length === 0" class="text-center py-5">
          <i class="pi pi-info-circle" style="font-size:2.5rem; color:#94a3b8;"></i>
          <p class="mt-3 text-muted">لا توجد سنوات دراسية مفعّلة حالياً.</p>
          <router-link to="/academic-years" class="btn PrimaryButton mt-2">
            <i class="pi pi-cog me-1"></i> إعداد السنوات الدراسية
          </router-link>
        </div>

        <template v-else>

          <!-- Primary -->
          <template v-if="gradesByStage.primary.length">
            <div class="section-header mb-3">
              <span class="section-label">المرحلة الابتدائية</span>
              <div class="section-divider"></div>
            </div>
            <div class="row g-4 mb-5">
              <div v-for="(grade, i) in gradesByStage.primary" :key="grade.id" class="col-xl-3 col-lg-6 col-md-6 col-12">
                <GradeCard :grade="grade" :color="cardColor(i)" :gradeRoute="gradeRoute" @link-click="onGradeCardClick(grade)" />
              </div>
            </div>
          </template>

          <!-- Prep -->
          <template v-if="gradesByStage.prep.length">
            <div class="section-header mb-3">
              <span class="section-label">المرحلة الإعدادية</span>
              <div class="section-divider"></div>
            </div>
            <div class="row g-4 mb-5">
              <div v-for="(grade, i) in gradesByStage.prep" :key="grade.id" class="col-xl-3 col-lg-6 col-md-6 col-12">
                <GradeCard :grade="grade" :color="cardColor(i + 2)" :gradeRoute="gradeRoute" @link-click="onGradeCardClick(grade)" />
              </div>
            </div>
          </template>

          <!-- Secondary -->
          <template v-if="gradesByStage.secondary.length">
            <div class="section-header mb-3">
              <span class="section-label">المرحلة الثانوية</span>
              <div class="section-divider"></div>
            </div>
            <div class="row g-4 mb-5">
              <div v-for="(grade, i) in gradesByStage.secondary" :key="grade.id" class="col-xl-3 col-lg-6 col-md-6 col-12">
                <GradeCard :grade="grade" :color="cardColor(i)" :gradeRoute="gradeRoute" @link-click="onGradeCardClick(grade)" />
              </div>
            </div>
          </template>

        </template>

        <!-- Admin Section -->
        <div class="section-header mb-3">
          <span class="section-label">الإدارة</span>
          <div class="section-divider"></div>
        </div>

        <div class="row g-4 align-items-start">
          <div class="col-xl-3 col-lg-6 col-md-6 col-12">
            <div class="module-card module-card--indigo">
              <div class="module-card__header">
                <div class="module-card__icon-wrap"><i class="pi pi-globe"></i></div>
                <h3 class="module-card__title">الموقع الإلكتروني</h3>
              </div>
              <div class="module-card__body">
                <router-link to="/website_text" class="module-link">
                  <i class="pi pi-align-right"></i><span>نصوص الموقع</span>
                </router-link>
                <router-link to="/whatsapp_links" class="module-link">
                  <i class="pi pi-comments"></i><span>لينكات واتساب</span>
                </router-link>
                <router-link to="/whatsapp_groups" class="module-link">
                  <i class="pi pi-users"></i><span>مجموعات واتساب</span>
                </router-link>
                <router-link to="/website_time" class="module-link">
                  <i class="pi pi-clock"></i><span>بداية الحجز</span>
                </router-link>
                <router-link to="/web_status" class="module-link">
                  <i class="pi pi-power-off"></i><span>حالة الحجز</span>
                </router-link>
                <router-link to="/about" class="module-link">
                  <i class="pi pi-info-circle"></i><span>من نحن</span>
                </router-link>
                <router-link to="/blog" class="module-link">
                  <i class="pi pi-pencil"></i><span>المدونة</span>
                </router-link>
                <router-link to="/banners" class="module-link">
                  <i class="pi pi-images"></i><span>بانرات الموقع</span>
                </router-link>
                <router-link to="/homepage-builder" class="module-link">
                  <i class="pi pi-desktop"></i><span>الصفحة الرئيسية</span>
                </router-link>
                <router-link to="/student-notifications" class="module-link">
                  <i class="pi pi-bell"></i><span>إشعارات الطلاب</span>
                </router-link>
              </div>
              <div class="module-card__footer">
                <div></div>
                <router-link to="/web_status" class="module-card__cta">
                  <span>إدارة الموقع</span>
                  <i class="pi pi-arrow-left"></i>
                </router-link>
              </div>
            </div>
          </div>

          <div class="col-xl-3 col-lg-6 col-md-6 col-12">
            <div class="module-card module-card--teal">
              <div class="module-card__header">
                <div class="module-card__icon-wrap"><i class="pi pi-cog"></i></div>
                <h3 class="module-card__title">إعداد</h3>
              </div>
              <div class="module-card__body">
                <router-link to="/all_student" class="module-link">
                  <i class="pi pi-database"></i>
                  <span>عرض جميع الطلاب</span>
                </router-link>
                <router-link to="/academic-years" class="module-link">
                  <i class="pi pi-sliders-h"></i>
                  <span>تفعيل / تعطيل المراحل</span>
                </router-link>
                <router-link to="/financial-settings" class="module-link">
                  <i class="pi pi-wallet"></i>
                  <span>إدارة البنود المالية</span>
                </router-link>
                <router-link to="/schedule" class="module-link">
                  <i class="pi pi-calendar"></i>
                  <span>الجدول الدراسي</span>
                </router-link>
                <button type="button" class="module-link" @click="openRegistrationFormSettings">
                  <i class="pi pi-file-edit"></i>
                  <span>إعدادات التسجيل</span>
                </button>
              </div>
              <div class="module-card__footer">
                <div></div>
                <router-link to="/academic-years" class="module-card__cta">
                  <span>إدارة المراحل</span>
                  <i class="pi pi-arrow-left"></i>
                </router-link>
              </div>
            </div>
          </div>

          <!-- الأمان وإدارة الأجهزة ("One Device Per Student") -->
          <div class="col-xl-3 col-lg-6 col-md-6 col-12">
            <div class="module-card module-card--slate">
              <div class="module-card__header">
                <div class="module-card__icon-wrap"><i class="pi pi-shield"></i></div>
                <h3 class="module-card__title">الأمان وإدارة الأجهزة</h3>
              </div>
              <div class="module-card__body">
                <router-link to="/students/devices" class="module-link">
                  <i class="pi pi-mobile"></i>
                  <span>الأجهزة المسجلة</span>
                </router-link>
                <router-link to="/students/device-requests" class="module-link">
                  <i class="pi pi-sync"></i>
                  <span>طلبات تغيير الجهاز</span>
                </router-link>
                <router-link to="/students/device-audit-logs" class="module-link">
                  <i class="pi pi-history"></i>
                  <span>سجل أحداث الأجهزة</span>
                </router-link>
                <router-link to="/students/exam-access" class="module-link">
                  <i class="pi pi-eye"></i>
                  <span>تتبّع دخول الامتحانات</span>
                </router-link>
                <router-link to="/students/registration-reset" class="module-link">
                  <i class="pi pi-refresh"></i>
                  <span>إعادة تسجيل الطلاب</span>
                </router-link>
                <router-link to="/settings/app-version" class="module-link">
                  <i class="pi pi-cloud-download"></i>
                  <span>إعدادات إصدار التطبيق</span>
                </router-link>
              </div>
              <div class="module-card__footer">
                <div></div>
                <router-link to="/students/devices" class="module-card__cta">
                  <span>إدارة الأجهزة</span>
                  <i class="pi pi-arrow-left"></i>
                </router-link>
              </div>
            </div>
          </div>

          <!-- الرسائل -->
          <div class="col-xl-3 col-lg-6 col-md-6 col-12">
            <div class="module-card module-card--green">
              <div class="module-card__header">
                <div class="module-card__icon-wrap"><i class="pi pi-comments"></i></div>
                <h3 class="module-card__title">الرسائل</h3>
              </div>
              <div class="module-card__body">
                <div v-if="loadingTemplates" class="py-2 text-center">
                  <i class="pi pi-spin pi-spinner" style="color:var(--gold)"></i>
                </div>
                <router-link
                  v-for="tpl in sortedTemplates"
                  :key="tpl.id"
                  :to="templatePath(tpl.code)"
                  class="module-link"
                >
                  <i class="pi" :class="templateIcon(tpl.code)"></i>
                  <span>{{ tpl.name }}</span>
                  <span v-if="!tpl.is_active" class="module-link-badge module-link-badge--off">معطّل</span>
                </router-link>
              </div>
              <div class="module-card__footer">
                <div></div>
                <router-link to="/messages" class="module-card__cta">
                  <span>إدارة الرسائل</span>
                  <i class="pi pi-arrow-left"></i>
                </router-link>
              </div>
            </div>
          </div>

          <!-- المتابعة الدورية -->
          <div class="col-xl-3 col-lg-6 col-md-6 col-12" data-testid="follow-up-dashboard">
            <div class="module-card module-card--teal">
              <div class="module-card__header">
                <div class="module-card__icon-wrap"><i class="pi pi-list-check" aria-hidden="true"></i></div>
                <h3 class="module-card__title">المتابعة الدورية</h3>
              </div>
              <div class="module-card__body">
                <router-link to="/follow-ups" class="module-link">
                  <i class="pi pi-list" aria-hidden="true"></i><span>المتابعة الدورية</span>
                </router-link>
                <router-link to="/follow-up-types" class="module-link">
                  <i class="pi pi-tags" aria-hidden="true"></i><span>أنواع المتابعات</span>
                </router-link>
              </div>
            </div>
          </div>

          <!-- الاشتراكات والمدفوعات -->
          <div class="col-xl-3 col-lg-6 col-md-6 col-12">
            <div class="module-card module-card--amber">
              <div class="module-card__header">
                <div class="module-card__icon-wrap"><i class="pi pi-credit-card"></i></div>
                <h3 class="module-card__title">الاشتراكات والمدفوعات</h3>
              </div>
              <div class="module-card__body">
                <router-link to="/courses" class="module-link">
                  <i class="pi pi-book"></i><span>الكورسات</span>
                </router-link>
                <router-link to="/subscriptions" class="module-link">
                  <i class="pi pi-id-card"></i><span>الاشتراكات</span>
                </router-link>
                <router-link to="/student-subscriptions" class="module-link">
                  <i class="pi pi-users"></i><span>اشتراكات الطلاب</span>
                </router-link>
                <router-link to="/payment-methods" class="module-link">
                  <i class="pi pi-wallet"></i><span>طرق الدفع</span>
                </router-link>
                <router-link to="/payment-requests" class="module-link">
                  <i class="pi pi-inbox"></i><span>طلبات الدفع</span>
                  <span v-if="pendingPayments" class="module-link-badge">{{ pendingPayments }}</span>
                </router-link>
                <router-link to="/subscription-reports" class="module-link">
                  <i class="pi pi-chart-line"></i><span>تقارير الاشتراكات</span>
                </router-link>
              </div>
              <div class="module-card__footer">
                <div></div>
                <router-link to="/subscriptions" class="module-card__cta">
                  <span>إدارة الاشتراكات</span>
                  <i class="pi pi-arrow-left"></i>
                </router-link>
              </div>
            </div>
          </div>

          <!-- سلة المحذوفات -->
          <div class="col-xl-3 col-lg-6 col-md-6 col-12">
            <div class="module-card module-card--rose">
              <div class="module-card__header">
                <div class="module-card__icon-wrap"><i class="pi pi-trash"></i></div>
                <h3 class="module-card__title">سلة المحذوفات</h3>
              </div>
              <div class="module-card__body">
                <router-link to="/recycle-bin" class="module-link">
                  <i class="pi pi-calendar-times"></i><span>العناصر المحذوفة</span>
                </router-link>
              </div>
              <div class="module-card__footer">
                <div></div>
                <router-link to="/recycle-bin" class="module-card__cta">
                  <span>إدارة سلة المحذوفات</span>
                  <i class="pi pi-arrow-left"></i>
                </router-link>
              </div>
            </div>
          </div>

        </div>

      </template>

    </div>

    <RegistrationFormSettingsModal
      v-model="formSettingsModalOpen"
      :academic-year-id="formSettingsGradeId"
    />
  </div>
</template>

<script>
import axios from 'axios';
import { useGradeStore } from '@/stores/useGradeStore.js';
import { usePaymentRequestStore } from '@/stores/usePaymentRequestStore.js';
import GradeCard from '@/components/grades/GradeCard.vue';
import RegistrationFormSettingsModal from '@/views/academic_years/RegistrationFormSettingsModal.vue';

const COLORS = [
  'module-card--blue',
  'module-card--green',
  'module-card--purple',
  'module-card--amber',
  'module-card--indigo',
  'module-card--slate',
  'module-card--rose',
  'module-card--teal',
];

const TEMPLATE_ICON_MAP = {
  absence_notification:      'pi-calendar-times',
  absence_notification_bulk: 'pi-users',
  payment_reminder:          'pi-bell',
  payment_confirmation:      'pi-check-circle',
  payment_reminder_bulk:     'pi-bell',
  reservation_notification:  'pi-bookmark',
  attendance_confirmation:   'pi-check',
};

const TEMPLATE_SLUG_MAP = {
  payment_confirmation:      '/messages/payment-confirmation',
  payment_reminder:          '/messages/payment-reminder',
  payment_reminder_bulk:     '/messages/payment-reminder',
  absence_notification:      '/messages/absence',
  absence_notification_bulk: '/messages/absence-bulk',
  reservation_notification:  '/messages/reservation',
  attendance_confirmation:   '/messages/attendance-confirmation',
};

const TEMPLATE_SORT = {
  payment_confirmation:      1,
  payment_reminder:          2,
  payment_reminder_bulk:     3,
  absence_notification:      4,
  absence_notification_bulk: 5,
  reservation_notification:  6,
  attendance_confirmation:   7,
};

export default {
  name: 'dashboard-home',
  components: { GradeCard, RegistrationFormSettingsModal },

  data() {
    return {
      whatsappTemplates: [],
      loadingTemplates:  true,
      formSettingsModalOpen: false,
      formSettingsGradeId: null,
    };
  },

  computed: {
    gradeStore() { return useGradeStore(); },
    pendingPayments() { return usePaymentRequestStore().pendingCount; },
    activeGrades() { return this.gradeStore.activeGrades; },
    loading() { return this.gradeStore.loading; },
    gradesByStage() { return this.gradeStore.activeGradesByStage; },
    sortedTemplates() {
      // Payment Confirmation and Attendance Confirmation are disabled
      // project-wide — hide their dashboard shortcuts too, not just the
      // backend send. Sending itself is hard-disabled in
      // StudentPaymentController regardless of this list.
      return [...this.whatsappTemplates]
        .filter((tpl) => tpl.code !== 'payment_confirmation' && tpl.code !== 'attendance_confirmation')
        .sort((a, b) => {
          const oa = TEMPLATE_SORT[a.code] ?? 99;
          const ob = TEMPLATE_SORT[b.code] ?? 99;
          return oa - ob;
        });
    },
  },

  methods: {
    canAny(permissions) {
      return permissions.some((name) => this.$store.getters.can(name));
    },
    cardColor(i) {
      return COLORS[i % COLORS.length];
    },
    gradeRoute(grade, module) {
      const s = grade.slug;
      const routes = {
        students:   `/grades/${s}/students`,
        add:        `/grades/${s}/students/add`,
        absence:    `/grades/${s}/absence`,
        attendance: `/grades/${s}/attendance`,
        payments:   `/grades/${s}/payments`,
        groups:     `/grades/${s}/groups`,
        branch:     `/branch/${s}`,
        unit:       `/unit/${s}`,
        lesson:     `/lesson/${s}`,
        content:    `/${s}/content`,
        questions:  `/${s}/questions`,
        exams:      `/${s}/exams`,
      };
      return routes[module] ?? '/';
    },
    onGradeCardClick(grade) {
      this.gradeStore.setCurrentGrade(grade);
    },
    openRegistrationFormSettings() {
      // No fixed academic year in this context — the modal shows its own
      // PrimeVue-based year picker step first when opened without one.
      this.formSettingsGradeId = null;
      this.formSettingsModalOpen = true;
    },
    templateIcon(code) {
      return TEMPLATE_ICON_MAP[code] ?? 'pi-envelope';
    },
    templatePath(code) {
      return TEMPLATE_SLUG_MAP[code] ?? '/messages';
    },
    async loadTemplates() {
      this.loadingTemplates = true;
      try {
        const res = await axios.get('/whatsapp-templates');
        this.whatsappTemplates = res.data.data ?? [];
      } catch { /* non-fatal — dashboard still works */ } finally {
        this.loadingTemplates = false;
      }
    },
  },

  async mounted() {
    await this.gradeStore.fetchActiveGrades();
    this.gradeStore.restoreCurrentGrade();
    this.loadTemplates();
    // Pending payment-requests badge (non-fatal if the admin lacks access).
    usePaymentRequestStore().fetchPendingCount().catch(() => {});
  },
};
</script>

<style scoped>
/* .module-link is styled for <router-link>; normalize native <button> chrome so the
   "إعدادات التسجيل" trigger (which must open a modal, not navigate) matches its sibling
   grid items exactly. Only font-family is reset here — `font: inherit` would also reset
   font-size via its higher specificity than .module-link's own font-size rule, making the
   button inherit the page's 16px default instead of .module-link's 13px. */
button.module-link {
  appearance: none;
  -webkit-appearance: none;
  border: none;
  outline: none;
  background: none;
  margin: 0;
  cursor: pointer;
  font-family: inherit;
  text-align: inherit;
}
.module-link-badge {
  margin-inline-start: auto;
  background: #ef4444;
  color: #fff;
  font-size: 0.68rem;
  font-weight: 700;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 9px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.module-link-badge--off {
  background: #94a3b8;
}
</style>
